<template>
  <div class="hold__invoices">
    <vs-popup id="hold__invoices" classContent="popup-example payment_popup" title="Hold Invoices" :active.sync="is_popup_hold_invoice_open">
      <hold-invoices-table :get_hold_invoices="get_hold_invoices" @close_hold_invoices_table="onCloseHoldInvoicePopup" />
    </vs-popup>
  </div>
</template>

<script>
import HoldInvoicesTable from './HoldInvoicesTable.vue'
export default {
  name: 'HoldInvoiceList',
  data() {
    return {
      is_popup_hold_invoice_open: false,
      get_hold_invoices: false
    }
  },
  mounted() {
    // listen for popup close
    const next = this.$children[0].$refs.btnclose
    next.$el.addEventListener('click', this.onCloseHoldInvoicePopup, false)

    // toggle the popup
    this.$root.$on('toggle_hold_invoices', (status) => {
      this.get_hold_invoices = status
      this.is_popup_hold_invoice_open = status
    })
  },
  methods: {
    // close the hold invoice popup
    onCloseHoldInvoicePopup() {
      this.is_popup_hold_invoice_open = !this.is_popup_hold_invoice_open
      this.get_hold_invoices = this.is_popup_hold_invoice_open
      this.$root.$emit('close_hold_invoices', this.is_popup_hold_invoice_open)
    }
  },
  components: {
    HoldInvoicesTable
  },

  beforeRouteLeave(_, __, next) {
    this.is_popup_hold_invoice_open = false
    next()
  }
}
</script>

<style lang="scss" >
#hold__invoices {
  .vs-popup {
    width: 50% !important;

    .vs-popup--header {
      background: rgb(0, 102, 34);
      border-radius: unset;
      padding: 0px;

      h3 {
        color: #fff;
        text-align: center;
      }
    }

    .checkout_details {
      .vx-row {
        font-weight: 700;
        text-align: right;

        .checkout_detail_value {
          font-weight: bold;
          font-size: 14px;
        }
      }
    }

    .plants_batch_details {
      .vs-con-tbody {
        max-height: 300px;
        overflow-y: auto;
      }

      table {
        border-collapse: unset !important;
        border-spacing: 0px;
      }

      .vs-con-tbody {
        .plant__check_box {
          width: 100px;
        }
      }
    }

    .close__btn {
      position: absolute;
      border: unset;
      right: 0;
      top: -15px;

      .vs-icon {
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
}
</style>